import { CommonModule } from '@angular/common';
import { Component, computed, effect, inject, Signal, signal, WritableSignal } from '@angular/core';
import { BackgroundColorDirective, DcThemeService } from '@dartcounter/ui';
import { DotLottieWebWorkerComponent } from 'ngx-dotlottie-web/src/webworker';
import { ScreenOrientationService } from 'src/app/shared/services/screen-orientation.service';

import { SplashOverlayService } from './splash-overlay.service';

@Component({
    selector: 'app-splash-overlay',
    standalone: true,
    templateUrl: './splash-overlay.component.html',
    styleUrls: ['./splash-overlay.component.css'],
    imports: [CommonModule, BackgroundColorDirective, DotLottieWebWorkerComponent],
})
export class SplashOverlayComponent {
    private splashOverlayService: SplashOverlayService = inject(SplashOverlayService);
    private themeService: DcThemeService = inject(DcThemeService);
    private screenOrientationService: ScreenOrientationService = inject(ScreenOrientationService);

    public isVisible: Signal<boolean> = computed(() => this.splashOverlayService.isVisible());
    public isAppLaunch: Signal<boolean> = computed(() => this.splashOverlayService.isAppLaunch());
    public showSplashData: WritableSignal<boolean> = signal(false);

    public lottieData: Signal<ArrayBuffer | null> = computed(() => this.splashOverlayService.lottieData());

    public darkText: Signal<boolean> = computed(
        () => this.isAppLaunch() || this.themeService.currentTheme() === 'light'
    );
    public isLandscape: Signal<boolean> = computed(() => this.screenOrientationService.isLandscape());

    constructor() {
        effect(() => {
            if (this.isVisible()) {
                this.setShowSplashData();
            } else {
                this.showSplashData.set(false);
            }
        });
    }

    private async setShowSplashData(): Promise<void> {
        await new Promise((r) => requestAnimationFrame(r));
        this.showSplashData.set(true);
    }
}
